import { steamLoginUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function SteamLoginButton({ className = "", size = "default", label = "Se connecter avec Steam" }) {
  return (
    <Button
      asChild
      size={size}
      className={`bg-[#171a21] hover:bg-[#1b2838] text-white border border-[#2a3f5f] gap-2 ${className}`}
      data-testid="steam-login-button"
    >
      <a href={steamLoginUrl}>
        <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden>
          <path d="M12 0C5.652 0 .43 4.945 0 11.211l6.446 2.669a3.395 3.395 0 0 1 1.905-.582c.086 0 .17.005.254.011l2.867-4.148v-.058a4.526 4.526 0 0 1 4.522-4.522 4.526 4.526 0 0 1 4.522 4.522 4.528 4.528 0 0 1-4.535 4.522l-4.086 2.918c0 .073.012.144.012.216 0 1.878-1.529 3.407-3.407 3.407-1.646 0-3.032-1.175-3.34-2.735L.038 15.05C1.36 20.19 5.97 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
        </svg>
        {label}
      </a>
    </Button>
  );
}
